module.exports = __webpack_public_path__ + "img/logo.9f79cf9e.svg";